import React from 'react';
import { Button, Typography, Layout } from 'antd';
import logo from '../images/logo.png';

const { Title, Text, Paragraph } = Typography;
const { Content } = Layout;

const LandingPage = () => {

    const apkLink = "https://www.dropbox.com/scl/fi/4lar5e6krphm0jm1ak12o/FitLab.apk?rlkey=lxag2vbwuccvqeb99w4vtqdzm&st=v00xvdqt&dl=1";
    
    return (
        <Layout style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'var(--sfondo)' }}>
            <Content style={{ textAlign: 'center', backgroundColor: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', maxWidth: '400px', width: '100%' }}>
                <img 
                    src={logo} 
                    alt="App Logo" 
                    style={{ width: '100%', maxWidth: '150px', marginBottom: '20px' }} 
                />
                <div className="ancdroid-title">
                    SCARICA L'APP
                </div>
                <Text style={{ display: 'block', marginBottom: '20px', color: 'var(--testo)' }}>
                    Scarica la nostra app e inizia a scoprire tutte le sue funzionalità!
                </Text>
                <Button 
                    type="primary" 
                    size="large" 
                    href={apkLink} 
                    target="_blank" 
                    style={{ backgroundColor: 'var(--primario)', borderColor: 'var(--primario)', width: '100%', padding: '10px', marginBottom: '20px' }}
                >
                    Scarica l'App
                </Button>
                <Title level={4}>Istruzioni per l'installazione</Title>
                <Paragraph style={{ color: 'var(--testo)', textAlign: 'left' }}>
                    Dopo aver scaricato l'APK:
                    <ul style={{ textAlign: 'left' }}>
                        <li>Apri il file scaricato dalla cartella Download.</li>
                        <li>Potrebbe apparire un avviso di sicurezza che richiede l'autorizzazione per installare da fonti sconosciute.</li>
                        <li>Vai alle <b>Impostazioni</b> e abilita l'opzione <b>Consenti da questa fonte</b> (o simile) per continuare.</li>
                        <li>Una volta abilitato, torna indietro e completa l’installazione dell’app.</li>
                    </ul>
                </Paragraph>
            </Content>
        </Layout>
    );
};

export default LandingPage;
